import React from 'react';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CallIcon from '@mui/icons-material/Call';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import './styles.css';

const ContactUsPanel: React.FC = () => (
  <Container
    maxWidth="xl"
    sx={{ marginTop: 5, paddingTop: 10, paddingBottom: 10 }}
    className="contact_us_backdrop"
  >
    <Box className="container">
      <Typography
        gutterBottom
        variant="h3"
        sx={{ marginBottom: 5 }}
        className="title"
      >
        Contact Us
      </Typography>
      <Grid container justifyContent="center" spacing={2}>
        <Grid item sm={12} md={3}>
          <Stack direction="column" spacing={1}>
            <Stack direction="row" spacing={1} className="mobile_no_row">
              <IconButton
                aria-label="mobile no"
                color="primary"
                onClick={() => window.open('tel:+94777246072', '_self')}
              >
                <CallIcon />
              </IconButton>
              <Typography gutterBottom variant="body1">
                +(94)-777-246072
              </Typography>
            </Stack>
            <Stack direction="row" spacing={1} className="mobile_no_row">
              <IconButton
                aria-label="mobile no"
                color="primary"
                onClick={() => window.open('tel:+94715971038', '_self')}
              >
                <CallIcon />
              </IconButton>
              <Typography gutterBottom variant="body1">
                +(94)-715-971038
              </Typography>
            </Stack>
            <Stack direction="row" spacing={1} className="mobile_no_row">
              <IconButton
                aria-label="mobile no"
                color="primary"
                onClick={() => window.open('tel:+94112907312', '_self')}
              >
                <CallIcon />
              </IconButton>
              <Typography gutterBottom variant="body1">
                +(94)-112-907312
              </Typography>
            </Stack>
          </Stack>
        </Grid>
        <Grid item sm={12} md={3} className="info_tile">
          <Stack direction="column" spacing={1}>
            <Stack direction="row" spacing={1} className="mobile_no_row">
              <IconButton
                aria-label="email address"
                color="primary"
                onClick={() =>
                  window.open('mailto:mangala.boralessa@gmail.com', '_self')
                }
              >
                <EmailIcon />
              </IconButton>
              <Typography gutterBottom variant="body1">
                mangala.boralessa@gmail.com
              </Typography>
            </Stack>
            <Stack direction="row" spacing={1} className="mobile_no_row">
              <IconButton aria-label="location address" color="primary">
                <LocationOnIcon />
              </IconButton>
              <Typography gutterBottom variant="body1">
                No 172/9 Bathiya Mawatha, Makola Road, Kiribathgoda, Sri Lanka
              </Typography>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  </Container>
);

export default ContactUsPanel;
